<template>
    <button @click.prevent="$emit('toggleView', 'cart')" class="c-overlay__notebook__tools__link">
        <svg aria-hidden="true" focusable="false" class="o-ico c-overlay__notebook__tools__link__icon">
            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#arrow-left"></use>
        </svg>
        Retour
    </button>
    <div class="o-spacer-sm"></div>
    <div class="o-flex -flex-direction-column -flex-middle -flex-grow-1 -flex-overflow-auto -flex-width-100p">
        <div class="o-form -form-dark">
            <div class="o-flex -flex-direction-column">
                <div class="o-form__group">
                    <label for="email" class="o-label sr-only">
                        Courriel
                    </label>
                    <input class="o-input" type="email" id="email" v-model="username" placeholder="Courriel" required>
                </div>
                <div v-if="error" class="o-alert -alert-error">
                    {{ error }}
                </div>
                <div class="o-flex -flex-space-between -flex-middle">
                    <button @click.prevent="forgot()" class="c-overlay__notebook__button__login">
                        Récupérer mon mot de passe
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CarnetLogin',
    data() {
        return {
            username: '',
            error: ''
            //
        }
    },
    mounted() {
    },
    methods: {
        forgot() {
            fetch(WPURLS.ajax_url+'?action=carnet_ajaxforgot',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': WPURLS.nonce,
                    },
                    body: JSON.stringify({
                        user_login: this.username
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success === true) {
		            	this.error = data.message;
                        this.username = '';
		        	} else if (data.message !== undefined) {
		            	this.error = data.message;
		        	} else {
		        		this.error = data;
		        	}
                });
        },
    }
}
</script>